<template>
  <div>
    <div small>
      <v-card class="px-4" flat>
        <v-layout wrap v-if="isUsingSelectEntireEducationOrCertification" mt-2>
          <v-flex xs12>
            <select-entire-education-or-certification :index="index" :isEducationNotCertification="false" :profile="profile" :isFromToken="isFromToken" @setIsUsingSelectEntireEducationOrCertification="setIsUsingSelectEntireEducationOrCertification"/>
          </v-flex>
        </v-layout>
        <v-layout v-else wrap mb-6 pt-6>
          <v-flex xs7>
            <v-btn @click="isUsingSelectEntireEducationOrCertification = true" small class="primary white--text">
              <v-icon small class="mr-2">mdi-select-drag</v-icon>{{ $t('a') }}
            </v-btn>
          </v-flex>
          <v-flex xs5>
            <v-layout wrap>
              <v-flex style="padding-top: 6px">
                <v-btn @click="convertCertificationToEducation" x-small outlined>
                  <v-icon x-small class="mr-2">mdi-sync</v-icon>
                  {{ $t('convert') }}
                </v-btn>
              </v-flex>
              <v-flex text-end>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab @click="removeCertification" x-small elevation="0" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <small>{{ $t('deleteTooltip') }}</small>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 mt-6>
            <v-layout wrap justify-space-between>
              <v-flex xs5>
                <v-text-field v-model="profile.certifications[index].startYear" dense outlined :label="$t('2')"/>
              </v-flex>
              <v-flex xs5>
                <v-text-field v-model="profile.certifications[index].endYear" dense outlined :label="$t('3')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field v-model="profile.certifications[index].institute" dense outlined :label="$t('4')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field v-model="profile.certifications[index].description" dense outlined :label="$t('5')"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
  </div>
</template>

<script>
import SelectEntireEducationOrCertification from '@/components/profile/SelectEntireEducationOrCertification.vue';

export default {
  components: {
    SelectEntireEducationOrCertification
  },
  props: {
    profile: Object,
    isOcrResultsLoaded: Boolean,
    index: Number,
    isFromToken: Boolean
  },
  data: () => ({
    isUsingSelectEntireEducationOrCertification: false
  }),
  methods: {
    removeCertification() {
      this.profile.certifications.splice(this.index, 1);
      const certificationsLength = this.profile.certifications.length
      if (certificationsLength > 0) {
        if (this.index > 0) this.$emit('goToEditPreviousItem')
      } else {
        this.$emit('goBackToMainForm', { idOfElementToScrollTo: 'view-certifications', idOfElementToBlink: 'view-certifications', blinkColor: 'red', additionalPixels: -300 })
      }
    },
    convertCertificationToEducation() {
      this.profile.educations.push(JSON.parse(JSON.stringify(this.profile.certifications[this.index])))
      this.profile.certifications.splice(this.index, 1);
      this.$emit('setFieldPath', { fieldPath: ['educations', this.profile.educations.length-1], savedScrollEltId: `view-educations-${this.profile.educations.length-1}` })
      this.$emit('updateProfileAndCreateDossier', { isOnlyToUpdateProfile: true })
      this.$emit('showIsSavingIconAFewSeconds')
    },
    setIsUsingSelectEntireEducationOrCertification(data) {
      this.isUsingSelectEntireEducationOrCertification = data.isUsingSelectEntireEducationOrCertification
    }
  },
  watch: {
    isUsingSelectEntireEducationOrCertification: {
      handler() {
        this.$emit('passIsUsingSelectEntireEducationOrCertification', { isUsingSelectEntireEducationOrCertification: this.isUsingSelectEntireEducationOrCertification })
      }
    },
  }
}
</script>





<i18n>
{
  "fr": {
    "a": "Extraire toute la certification d'un seul coup",
    "1": "Certification",
    "2": "Année de début",
    "3": "Année de fin",
    "4": "Institut",
    "5": "Description",
    "convert": "Convertir en diplôme",
    "deleteTooltip": "Supprimer la certification"
  },
  "en": {
    "a": "Extract the entire certification at once",
    "1": "Certification",
    "2": "Start year",
    "3": "End year",
    "4": "Institute",
    "5": "Description",
    "convert": "Convert to diploma",
    "deleteTooltip": "Delete the certification"
  }
}
</i18n>